export default __webpack_public_path__ + "static/media/prospectTenants.0235369a.png";